import React from 'react';
import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  TextField,
  Paper,
  Stack,
  List,
  ListItemButton,
  ListItemText,
  Typography,
} from '@mui/material';
import SaveOutlinedIcon from '@mui/icons-material/SaveOutlined';
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';
import { attachGooglePlaceSearch, loadGoogleMaps, reverseGeocode } from 'Includes/googleMaps';
import { getRequest, postRequest, putRequest } from 'Includes/api/apicall';
import { GET_URL, POST_URL, PUT_URL } from 'Includes/urls';
import { Link, useNavigate } from 'react-router-dom';
import _ from 'lodash';
import Form_Details from 'Containers/Company/static/company';
import DynamicForm from 'Components/DynamicForm';
import Swal from 'sweetalert2'
import { validateMobileNumber } from 'Includes/functions';


function CompanyAdd(props) {
  const{is_edit_form,company_id, agreementPrefill}=props;

  const [form_details, set_form_details] = React.useState(Form_Details[0]['page_details']['sub_sections'])
  const [loading, set_loading] = React.useState(true)
  const [submitDisable, set_submitDisable] = React.useState(false)
  const [field_details, set_field_details] = React.useState(null)
  const [company_details, set_company_details] = React.useState({})
  const [fieldErrors, set_fieldErrors] = React.useState({})
  const [updated_company_details, set_updated_company_details] = React.useState({})
  const [agreementFile, set_agreementFile] = React.useState(null)
  const [existingAgreementUrl, set_existingAgreementUrl] = React.useState('')
  const [existingAgreementId, set_existingAgreementId] = React.useState(null)
  const [billingFormKey, set_billingFormKey] = React.useState(0)
  const [openMapDialog, set_openMapDialog] = React.useState(false)
  const [mapLat, set_mapLat] = React.useState('')
  const [mapLng, set_mapLng] = React.useState('')
  const [mapSearchText, set_mapSearchText] = React.useState('')
  const [mapSearchResults, set_mapSearchResults] = React.useState([])
  const [mapSearchLoading, set_mapSearchLoading] = React.useState(false)
  const mapContainerRef = React.useRef(null)
  const googleMapRef = React.useRef(null)
  const markerRef = React.useRef(null)
  const placeInputRef = React.useRef(null)
  const navigate = useNavigate();

  const company = React.useRef(null);
  const active = React.useRef(null);
  const billing = React.useRef(null);

  React.useEffect(() => {
    if (is_edit_form) {
      getCompanyList(company_id);
    }
    else {
      if (agreementPrefill && typeof agreementPrefill === 'object') {
        const prefill = { ...agreementPrefill }
        const agreementId = prefill.agreementId
        updateDetails(prefill)
        if (agreementId) {
          set_existingAgreementId(agreementId)
        }
      } else {
        updateDetails()
      }
    }
  }, [])
  const getCompanySecondaryDetails = (id) => {
    return getRequest(GET_URL.companysecondarydetails.api, { company: id }, props).then(response => {
      if (response && response.status === 200) {
        const data = response.data.data || response.data || []
        if (data.length > 0) {
          return data[0]
        }
      }
      return null
    }).catch(() => null)
  }


  const getCompanyList = (id) => {
    const url = GET_URL.company.api + id + '/'
    const params = {}
    getRequest(url, params, props).then(async response => {
      if (response && response.status === 200) {
        set_updated_company_details(() => response.data.data)
        const secondaryDetails = await getCompanySecondaryDetails(id)
        const details = { ...response.data.data }
        if (secondaryDetails) {
          details.contact_person1 = details.contact_person1 || secondaryDetails.primary_contact_name || ''
          details.tel_num = details.tel_num || secondaryDetails.primary_contact_phone_number || ''
          details.contact_person2 = details.contact_person2 || secondaryDetails.employee1_name || ''
          details.tel_num_2 = details.tel_num_2 || secondaryDetails.employee1_phone_number || ''
          details.secondary_billing_address = secondaryDetails.billing_address || ''
          details.secondary_map_location = secondaryDetails.map_location || ''
          details.secondary_client_billing_status = secondaryDetails.client_billing_status || 'GOOD'
          set_existingAgreementUrl(secondaryDetails?.agreement_details?.file || '')
          set_existingAgreementId(secondaryDetails?.agreement || null)
        }
        updateDetails(details)
      }
    })
  }

  const updateDetails = (details) => {
    let field_details_temp = { company: [], active: [], contact: [], billing: [] }
    let company_details = {}
    const sectionMap = { company: 'company_details', active: 'active_details', billing: 'billing_details' }

    Object.keys(sectionMap).forEach((sectionKey) => {
      const detailsKey = sectionMap[sectionKey]
      let fieldsTemp = _.cloneDeep(form_details[detailsKey]['list'])
      if (sectionKey === 'billing') {
        fieldsTemp = [..._.cloneDeep(form_details['contact_details']['list']), ...fieldsTemp]
      }
      fieldsTemp.forEach((data) => {
        if (is_edit_form && data['name'] === 'create_company_url') return
        let value = data['default']
        if (details && details[data['name']] !== undefined && details[data['name']] !== null) {
          value = details[data['name']]
        }
        if (data.multiple) {
          const selected = Array.isArray(value)
            ? value
            : String(value || '').split(',').map((item) => item.trim()).filter(Boolean)
          value = selected.length ? selected : ['school']
        }
        data['default'] = value
        company_details[data['name']] = value
        field_details_temp[sectionKey].push(data)
      })
    })

    set_field_details(() => field_details_temp)
    set_company_details(() => company_details)
    set_loading(() => false)
  }

  const updateParent = (name, value) => {
    let company_details_temp = { ...company_details }
    company_details_temp[name] = value
    set_company_details(() => company_details_temp)
  }

  const updateBillingFormDefaults = (mapVal, addrVal) => {
    set_company_details((currentDetails) => {
      const merged = { ...currentDetails }
      if (mapVal !== undefined) merged.secondary_map_location = mapVal
      if (addrVal !== undefined) merged.secondary_billing_address = addrVal

      set_field_details((prev) => {
        if (!prev?.billing) return prev
        const nextBilling = prev.billing.map((field) => ({
          ...field,
          default: merged[field.name] !== undefined ? merged[field.name] : field.default,
        }))
        return { ...prev, billing: nextBilling }
      })
      set_billingFormKey((k) => k + 1)
      return merged
    })
  }

  const setMapLocationValue = (value) => updateBillingFormDefaults(value, undefined)
  const setBillingAddressValue = (value) => updateBillingFormDefaults(undefined, value)

  const fetchBillingAddressFromCoordinates = async (latitude, longitude) => {
    try {
      const payload = await reverseGeocode(latitude, longitude)
      const addressText = String(payload?.address || '').trim()
      if (addressText) {
        setBillingAddressValue(addressText)
        set_fieldErrors(prev => ({ ...prev, secondary_billing_address: '' }))
      }
    } catch (_error) {
      // Keep map selection even if reverse geocoding fails.
    }
  }

  const applyMapSelection = async (latitude, longitude, addressText = '') => {
    if (!Number.isFinite(Number(latitude)) || !Number.isFinite(Number(longitude))) return
    const normalizedLat = Number(latitude).toFixed(6)
    const normalizedLng = Number(longitude).toFixed(6)
    set_mapLat(normalizedLat)
    set_mapLng(normalizedLng)
    setMapLocationValue(`${normalizedLat},${normalizedLng}`)
    set_fieldErrors(prev => ({ ...prev, secondary_map_location: '' }))
    if (String(addressText || '').trim()) {
      setBillingAddressValue(String(addressText).trim())
      set_fieldErrors(prev => ({ ...prev, secondary_billing_address: '' }))
      return
    }
    await fetchBillingAddressFromCoordinates(normalizedLat, normalizedLng)
  }

  const validation = () => {
    let companyValidate = true
    let activeValidate = true
    let billingValidate = true

    let fieldErrors = {}
    field_details['company'].forEach((field) => {
      let value = company_details[field.name];
      let name = field.name;
      const emptyValue = Array.isArray(value) ? value.length === 0 : !Boolean(value)
      if (field.required && emptyValue) {
        fieldErrors[name] = 'This field is Mandatory'
        companyValidate = false
      }
      else if (field.type === 'phone_number') {
        let returnValue = validateMobileNumber(field, value)
        if (!returnValue.test) {
          fieldErrors[name] = returnValue.error
          companyValidate = false
        }
        else {
          value = returnValue.value
        }
      }
      else if (field.regex && !field.regex.value.test(value) && value !== '') {
        fieldErrors[name] = field.regex.errorText;
        companyValidate = false
      }
    })

    field_details['active'].forEach((field) => {
      let value = company_details[field.name];
      let name = field.name;
      if (field.required && !Boolean(value)) {
        fieldErrors[name] = 'This field is Mandatory'
        activeValidate = false
      }
      else if (field.type === 'phone_number') {
        let returnValue = validateMobileNumber(field, value)
        if (!returnValue.test) {
          fieldErrors[name] = returnValue.error
          activeValidate = false
        }
        else {
          value = returnValue.value
        }
      }
      else if (field.regex && !field.regex.value.test(value) && value !== '') {
        fieldErrors[name] = field.regex.errorText;
        activeValidate = false
      }
    })

    field_details['billing'].forEach((field) => {
      let value = company_details[field.name];
      let name = field.name;
      if (field.required && !Boolean(value)) {
        fieldErrors[name] = 'This field is Mandatory'
        billingValidate = false
      }
      else if (field.regex && !field.regex.value.test(value) && value !== '') {
        fieldErrors[name] = field.regex.errorText;
        billingValidate = false
      }
    })
    // if (!agreementFile && !existingAgreementId) {
    //   fieldErrors.secondary_agreement = 'Agreement is Mandatory'
    //   billingValidate = false
    // }
    let post_data = {}
    set_fieldErrors(() => fieldErrors)
    if (companyValidate && activeValidate && billingValidate) {
      post_data = {
        name: company_details['name'],
        code: company_details['code'],
        ownername: company_details['ownername'],
        phonenumber: company_details['phonenumber'],
        owneremail: company_details['owneremail'],
        type: company_details['type'],
        institute_type: Array.isArray(company_details['institute_type'])
          ? company_details['institute_type'].join(',')
          : (company_details['institute_type'] || 'school'),
        board_name: company_details['board_name'],
        fax_num: company_details['fax_num'],
        gstin_num: company_details['gstin_num'],
        database_key: company_details['database_key'],
        database_name: company_details['database_name'],
        domain: company_details['domain'],
        optional_domain_name: company_details['optional_domain_name'],
        enquiry_format: company_details['enquiry_format'],
        application_format: company_details['application_format'],
        admission_format: company_details['admission_format'],
        active: company_details['active'],
        create_company_url: company_details['create_company_url'],
        payment_gateway_enabled: company_details['payment_gateway_enabled'],
        biometric: company_details['biometric'],
        website: company_details['website'],

        from_date: company_details['from_date'],
        to_date: company_details['to_date'],
        total_aount: company_details['total_aount'],
        paid_aount: company_details['paid_aount'],
        to_date: company_details['to_date'],
        contact_person1: company_details['contact_person1'],
        contact_person2: company_details['contact_person2'],
        tel_num: company_details['tel_num'],
        tel_num_2: company_details['tel_num_2'],
        country: company_details['country'],
        state: company_details['state'],
        district: company_details['district'],
        city: company_details['city'],
        address: company_details['address'],
        pincode: company_details['pincode'],
        secondary_primary_contact_name: company_details['contact_person1'],
        secondary_primary_contact_phone_number: company_details['tel_num'],
        secondary_employee1_name: company_details['contact_person2'],
        secondary_employee1_phone_number: company_details['tel_num_2'],
        secondary_billing_address: company_details['secondary_billing_address'],
        secondary_map_location: company_details['secondary_map_location'],
        secondary_client_billing_status: company_details['secondary_client_billing_status'],
        secondary_agreement_id: existingAgreementId || '',
      }
    }
    else {
      if (!companyValidate) {
        company.current.updateErrors(fieldErrors)
      }
      if (!activeValidate) {
        active.current.updateErrors(fieldErrors)
      }
      if (!billingValidate) {
        billing.current.updateErrors(fieldErrors)
      }
      post_data = false
    }
    return post_data
  }

  const submit = () => {
    let validate_post_data = validation()
    if (validate_post_data) {
      // Send JSON payload (not FormData) to avoid immutable QueryDict on backend.
      // File upload (secondary_agreement) must be handled separately; this endpoint expects JSON.
      const payload = { ...validate_post_data }
      if (agreementFile) {
        Swal.fire({
          type: 'warning',
          title: 'Agreement file not uploaded',
          text: 'This form is sending JSON. Please upload the agreement file in Company Billing Details screen.',
        })
      }
      const reqProps = { ...props, contentType: 'application/json' }
      if (is_edit_form) {
        const url = PUT_URL.company.api + updated_company_details['id'] + '/'
        putRequest(url, payload, reqProps).then(response => {
          if (response && response.status === 200) {
            const Response = response.data
            Swal.fire({
              type: 'success',
              title: Response.Reason,
              text: 'School Information is Updated ',
              showConfirmButton: false,
              timer: 1500
            })
            const fromAgreement = Boolean(agreementPrefill && agreementPrefill.agreementId != null)
            navigate(fromAgreement ? '/agreement/list' : '/company/list')
          }
        })
      }
      else {
        const url = POST_URL.company.api
        postRequest(url, payload, reqProps).then(response => {
          if (response && response.status === 200) {
            const Response = response.data
            Swal.fire({
              type: 'success',
              title: Response.Reason,
              text: 'School Information is Updated ',
              showConfirmButton: false,
              timer: 1500
            })
            const fromAgreement = Boolean(agreementPrefill && agreementPrefill.agreementId != null)
            navigate(fromAgreement ? '/agreement/list' : '/company/list')
          }
        }).catch((error) => {
          const message =
            error?.response?.data?.name?.[0] ||
            error?.response?.data?.Reason ||
            'Unable to create company'
          Swal.fire({
            type: 'error',
            title: 'Error',
            text: message,
          })
        })
      }
    }
  }

  const sectionTitleSx = {
    mb: 2.5,
    pl: 1.75,
    borderLeft: '4px solid #4680FF',
    color: '#4680FF',
    fontWeight: 600,
    fontSize: { xs: '1rem', sm: '1.05rem' },
    lineHeight: 1.35,
  };

  const sectionPaperSx = {
    p: { xs: 2, sm: 2.5, md: 3 },
    borderRadius: 2,
    border: '1px solid',
    borderColor: 'divider',
    bgcolor: 'background.paper',
    boxShadow: '0 1px 2px rgba(15, 23, 42, 0.06)',
  };

  const openMapPicker = () => {
    const existingLocation = company_details?.secondary_map_location || ''
    if (existingLocation && existingLocation.includes(',')) {
      const [lat, lng] = existingLocation.split(',')
      set_mapLat(String(lat || '').trim())
      set_mapLng(String(lng || '').trim())
    }
    set_openMapDialog(true)
  }

  const placeMarker = (map, latitude, longitude) => {
    const maps = window.google?.maps
    if (!map || !maps) return
    const position = { lat: Number(latitude), lng: Number(longitude) }
    if (markerRef.current) markerRef.current.setPosition(position)
    else markerRef.current = new maps.Marker({ map, position, draggable: true })
    markerRef.current.addListener('dragend', (event) => {
      applyMapSelection(Number(event.latLng.lat()).toFixed(6), Number(event.latLng.lng()).toFixed(6))
    })
    map.panTo(position)
    map.setZoom(15)
  }

  const applyPlaceResult = (place) => {
    const latitude = Number(place?.lat).toFixed(6)
    const longitude = Number(place?.lng).toFixed(6)
    if (!Number.isFinite(Number(latitude)) || !Number.isFinite(Number(longitude))) return
    applyMapSelection(latitude, longitude, place?.address || place?.name || '')
    if (googleMapRef.current) placeMarker(googleMapRef.current, latitude, longitude)
  }

  const initializeGoogleMap = () => {
    if (!mapContainerRef.current) return
    const defaultLat = parseFloat(mapLat || '12.9716')
    const defaultLng = parseFloat(mapLng || '77.5946')
    loadGoogleMaps().then((maps) => {
      if (!mapContainerRef.current) return
      if (!googleMapRef.current) {
        const map = new maps.Map(mapContainerRef.current, {
          center: { lat: defaultLat, lng: defaultLng },
          zoom: 12,
          mapTypeControl: false,
          streetViewControl: false,
        })
        map.addListener('click', (event) => {
          const latitude = Number(event.latLng.lat()).toFixed(6)
          const longitude = Number(event.latLng.lng()).toFixed(6)
          applyMapSelection(latitude, longitude)
          placeMarker(map, latitude, longitude)
        })
        googleMapRef.current = map
      }
      const map = googleMapRef.current
      map.setCenter({ lat: defaultLat, lng: defaultLng })
      window.google.maps.event.trigger(map, 'resize')
      if (mapLat && mapLng) placeMarker(map, mapLat, mapLng)
    }).catch(() => {})
  }

  const closeMapDialog = () => {
    set_openMapDialog(false)
    googleMapRef.current = null
    markerRef.current = null
  }

  React.useEffect(() => {
    if (!openMapDialog) return undefined
    const timer = setTimeout(() => {
      initializeGoogleMap()
      attachGooglePlaceSearch(placeInputRef.current, applyPlaceResult)
    }, 50)
    return () => clearTimeout(timer)
  }, [openMapDialog])

  const loadCurrentCoordinatesInDialog = () => {
    if (!navigator.geolocation) {
      set_fieldErrors(prev => ({ ...prev, secondary_map_location: 'Geolocation is not supported in this browser' }))
      return
    }
    navigator.geolocation.getCurrentPosition(
      (position) => {
        const latitude = Number(position.coords.latitude).toFixed(6)
        const longitude = Number(position.coords.longitude).toFixed(6)
        applyMapSelection(latitude, longitude)
        if (googleMapRef.current) placeMarker(googleMapRef.current, latitude, longitude)
      },
      () => {
        set_fieldErrors(prev => ({ ...prev, secondary_map_location: 'Unable to get current coordinates' }))
      }
    )
  }

  const applyCoordinatesFromDialog = () => {
    const parsedLat = Number(String(mapLat).trim())
    const parsedLng = Number(String(mapLng).trim())
    if (!Number.isFinite(parsedLat) || !Number.isFinite(parsedLng)) {
      set_fieldErrors(prev => ({ ...prev, secondary_map_location: 'Please choose valid coordinates' }))
      return
    }
    const normalizedLat = parsedLat.toFixed(6)
    const normalizedLng = parsedLng.toFixed(6)
    set_mapLat(normalizedLat)
    set_mapLng(normalizedLng)
    setMapLocationValue(`${normalizedLat},${normalizedLng}`)
    set_fieldErrors(prev => ({ ...prev, secondary_map_location: '' }))
    closeMapDialog()
  }

  return (
    <>
      {loading && (
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            minHeight: 280,
            gap: 2,
            py: 6,
          }}
        >
          <CircularProgress size={40} thickness={4} />
          <Typography color="text.secondary" variant="body2">
            {is_edit_form ? 'Loading company details…' : 'Preparing form…'}
          </Typography>
        </Box>
      )}
      <Dialog
        open={openMapDialog}
        onClose={closeMapDialog}
        maxWidth="sm"
        fullWidth
        keepMounted
        TransitionProps={{
          onEntered: initializeGoogleMap,
        }}
      >
        <DialogTitle>Pick Map Coordinates</DialogTitle>
        <DialogContent>
          <style>{`.pac-container{z-index:2000 !important;}`}</style>
          <TextField
            inputRef={placeInputRef}
            label="Search Google Maps"
            placeholder="Private schools, colleges, or locations in Karnataka"
            fullWidth
            size="small"
            sx={{ mt: 1, mb: 2 }}
          />
          <Box mt={1} mb={2}>
            <Button
              variant="outlined"
              size="small"
              onClick={loadCurrentCoordinatesInDialog}
              sx={{ textTransform: 'none' }}
            >
              Use Current Location
            </Button>
          </Box>
          <Box
            mt={2}
            ref={mapContainerRef}
            sx={{
              width: '100%',
              height: 320,
              borderRadius: 1,
              border: '1px solid',
              borderColor: 'divider',
              overflow: 'hidden',
            }}
          />
          <Box mt={1}>
            <Typography variant="caption" color="text.secondary">
              Click anywhere on map to fetch and fill billing address.
            </Typography>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={closeMapDialog} color="inherit">Cancel</Button>
          <Button onClick={applyCoordinatesFromDialog} variant="contained">Use Selected Location</Button>
        </DialogActions>
      </Dialog>
      {!loading && field_details && (
        <Stack spacing={3} sx={{ pb: 2 }}>
          {field_details['company'] && (
            <Paper elevation={0} sx={sectionPaperSx}>
              <Typography variant="subtitle1" component="h2" sx={sectionTitleSx}>
                {form_details.company_details.label}
              </Typography>
              <DynamicForm
                fieldDetails={field_details['company']}
                updateParent={updateParent}
                isEditForm={is_edit_form}
                loading={loading}
                ref={company}
              />
            </Paper>
          )}

          {field_details['active'] && (
            <Paper elevation={0} sx={sectionPaperSx}>
              <Typography variant="subtitle1" component="h2" sx={sectionTitleSx}>
                {form_details.active_details.label}
              </Typography>
              <DynamicForm
                fieldDetails={field_details['active']}
                updateParent={updateParent}
                isEditForm={is_edit_form}
                loading={loading}
                ref={active}
              />
            </Paper>
          )}

          {field_details['billing'] && (
            <Paper elevation={0} sx={sectionPaperSx}>
              <Typography variant="subtitle1" component="h2" sx={sectionTitleSx}>
                {form_details.billing_details.label}
              </Typography>
              <DynamicForm
                key={`billing-${billingFormKey}`}
                fieldDetails={field_details['billing']}
                updateParent={updateParent}
                isEditForm={is_edit_form}
                loading={loading}
                ref={billing}
              />
              <Box mt={1.5} display="flex" gap={1.5} flexWrap="wrap">
                <Button
                  variant="contained"
                  size="small"
                  startIcon={<LocationOnOutlinedIcon />}
                  onClick={openMapPicker}
                  sx={{ textTransform: 'none' }}
                >
                  Pick Map Location
                </Button>
              </Box>
              {Boolean(fieldErrors.secondary_map_location) && (
                <Typography mt={1} variant="caption" color="error">
                  {fieldErrors.secondary_map_location}
                </Typography>
              )}
              <Box mt={2} mb={2}>
                <Divider />
              </Box>
              <Box mt={2}>
                <Typography variant="body2" color="text.secondary">
                  Agreement Attachment *
                </Typography>
                <Box mt={1}>
                  <input
                    type="file"
                    onChange={(e) => {
                      set_agreementFile(e.target.files?.[0] || null)
                      set_fieldErrors(prev => ({ ...prev, secondary_agreement: '' }))
                    }}
                  />
                </Box>
                {Boolean(fieldErrors.secondary_agreement) && (
                  <Typography variant="caption" color="error">
                    {fieldErrors.secondary_agreement}
                  </Typography>
                )}
                {(existingAgreementUrl && !agreementFile) && (
                  <Box mt={0.5}>
                    <Typography variant="caption" color="text.secondary">
                      Existing Agreement: <a href={existingAgreementUrl} target="_blank" rel="noreferrer">Download</a>
                    </Typography>
                  </Box>
                )}
              </Box>
            </Paper>
          )}

          <Paper
            elevation={0}
            sx={{
              ...sectionPaperSx,
              display: 'flex',
              flexWrap: 'wrap',
              alignItems: 'center',
              justifyContent: 'flex-end',
              gap: 1.5,
              pt: 2,
              pb: 2,
            }}
          >
            <Button
              variant="outlined"
              color="inherit"
              component={Link}
              to="/company/list"
              sx={{ textTransform: 'none', borderRadius: 2 }}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              color="primary"
              className="submit"
              disabled={submitDisable}
              onClick={submit}
              startIcon={<SaveOutlinedIcon />}
              sx={{ textTransform: 'none', borderRadius: 2, minWidth: 128 }}
            >
              {is_edit_form ? 'Save changes' : 'Create company'}
            </Button>
          </Paper>
        </Stack>
      )}
    </>
  )

}

export default CompanyAdd;